import { render, staticRenderFns } from "./newProductForm.vue?vue&type=template&id=4ffcc6f7&"
import script from "./newProductForm.vue?vue&type=script&lang=js&"
export * from "./newProductForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports